import { createStore } from 'vuex'

export default createStore({
state () {
  return {
    loginStatus:true,
  }
},
getters: {
},
mutations: {
  
},
actions: {
},
modules: {
}
})
